import fetch from '@/utils/fetch';

/**
 * 获取账号列表
 * @param query
 */
export function getAccountPage(query) {
    return fetch({
        url: '/ManageUser/ManageUser/getUserListByOrganizationId',
        method: 'post',
        data: query
    });
}


/**
 * 初始化用户信息
 */
export function getAccount(account) {
    return fetch({
        url: '/ManageUser/ManageUser/getOrganizationUserByUserId',
        method: 'post',
        data: account
    });
}

/**
 * 根据部门id获取职位列表
 * @param deparmentid 部门id
 */
export function getPostList(deparmentid) {
    return fetch({
        url: '/ManageRule/ManageRule/getPostList',
        method: 'post',
        data: deparmentid
    });
}



/**
 * 提交账号信息
 * @param account
 */
export function addAccount(account) {
    return fetch({
        url: '/ManageUser/ManageUser/registerOrganization',
        method: 'post',
        data: account
    });
}

/**
 * 提交账号信息
 * @param account
 */
export function delAccount(account) {
    return fetch({
        url: '/ManageUser/ManageUser/delOrganizationUser',
        method: 'post',
        data: account
    });
}

/**
 * 获取公司部门树列表
 * @param query
 */
export function getCompanyOrganizationTree(query) {
    return fetch({
        url: '/ManageRule/ManageRule/getCompanyOrganizationTree',
        method: 'post',
        data: query
    });
}

/**
 * 修改账号
 * @param query
 */
export function editAccount(query) {
    return fetch({
        url: '/ManageUser/ManageUser/updateOrganizationUser',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥有指定菜单权限的用户/机构/职位树
 * @param query
 */
export function getOrganizationAndPostAndUserTreeByMenu(query) {
    return fetch({
        url: '/ManageRule/ManageRule/getOrganizationAndPostAndUserTreeByMenu',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥有指定菜单权限的用户/机构/职位树
 * @param query
 */
export function resetPasswordFormAdmin(query) {
    return fetch({
        url: '/ManageUser/ManageUser/resetPasswordFormAdmin',
        method: 'post',
        data: query
    });
}

/**
 * 获取拥图片 token
 * @param query
 */
export function getFileToken(query) {
    return fetch({
        url: '/File/File/getFileToken',
        method: 'post',
        data: query
    });
}

/**
 * 图片删除
 * @param query
 */
export function detFile(query) {
    return fetch({
        url: '/File/File/deleteFile',
        method: 'post',
        data: query
    });
}

/**
 * 获取图片 key
 * @param query
 */
export function getViewKey(query) {
    return fetch({
        url: '/File/File/getToken',
        method: 'post',
        data: query
    });
}

/**
 * 获取图片 key
 * @param query
 */
export function userSeek(query) {
    return fetch({
        url: '/User/User/getUserListByWhere',
        method: 'post',
        data: query
    });
}

/**
 * 获取图片 key
 * @param query
 */
export function imageUrlPre(query) {
    return fetch({
        url: '/File/File/imageUrlPre',
        method: 'post',
        data: query
    });
}


// WEBPACK FOOTER //
// ./src/api/account.js